module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bn-5fd8c65274736a1b6af4a688b9965a55.svg";